import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 机构信息确认接口
 */
export class OrgBaseConfirmationController {
    constructor() {
        this.baseurl = 'OrgBaseConfirmationController.assx/';
    }

    /**
     * 根据编号查询详情
     * token:String, id:String
     */
    getOrgBaseConfirmationById(token, id){
        return request.post(this.baseurl + 'getOrgBaseConfirmationById', Qs.stringify({ token:token, id:id }));
    }

    /**
     * 修改（确认）
     * token:String, orgBaseConfirmation:OrgBaseConfirmation
     */
    updateOrgBaseConfirmation(token, orgBaseConfirmation){
        return request.post(this.baseurl + 'updateOrgBaseConfirmation', Qs.stringify({ token:token, orgBaseConfirmation:(typeof orgBaseConfirmation === 'undefined' || orgBaseConfirmation === null) ? '' : orgBaseConfirmation.toString() }));
    }

    /**
     * 查询列表
     * token:String, id:String, orgName:String, confirm:boolean, startIndex:int, maxSize:int
     */
    getOrgBaseConfirmationList(token, id, orgName, confirm, startIndex, maxSize){
        return request.post(this.baseurl + 'getOrgBaseConfirmationList', Qs.stringify({ token:token, id:id, orgName:orgName, confirm:confirm, startIndex:startIndex, maxSize:maxSize }));
    }

    /**
     * 新增机构信息确认
     * orgBaseConfirmation:OrgBaseConfirmation
     */
    addOrgBaseConfirmation(orgBaseConfirmation){
        return request.post(this.baseurl + 'addOrgBaseConfirmation', Qs.stringify({ orgBaseConfirmation:(typeof orgBaseConfirmation === 'undefined' || orgBaseConfirmation === null) ? '' : orgBaseConfirmation.toString() }));
    }
}